/*
 * Module for the topic label modal
 */

define([
  "marionette",
  "jquery",
  "underscore",
  "backbone",
  "messaging/messenger",
  "./localeMapView",
  "modules/accountAdmin/privilegeEnum",
  "modules/accountAdmin/kbRoleAdmin/kbRoleModel",
  "modules/header/kbMenu/kbMenuModel",
], function (
  Marionette,
  $,
  _,
  Backbone,
  Messenger,
  LocaleMapView,
  PrivilegeEnum,
  KbRoleModel,
  KbMenuModel,
) {
  var LOCALE_ALL_ID = 0;
  var LOCALE_TABLE_NAME = "BSE_LANGUAGE";

  var LocaleMapController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "localeMapModule";
      this.kbId = null;
    },
    show: function (kbRole) {
      this.kbRole = kbRole;
      if (!this.locales || this.kbId !== kbRole.get("kbId")) {
        this.kbId = kbRole.get("kbId");
        // Must fetch new collection of Locales, because we modify it by adding an All Locale
        // and by adding allowEdit, allowView, and allowDelete flags
        this.locales = Messenger.reqres.request("fetch:kb:languages", this.kbId);
        this.locales.onSynced(function () {
          if (this.locales.length > 1) {
            this.locales.each(function (locale) {
              locale.set("allowDelete", false);
              locale.set("allowEdit", false);
              locale.set("allowView", false);
            });
            var allLocales = new KbMenuModel.language({
              id: LOCALE_ALL_ID,
              locale: "all",
              name: $.t("admin.kbRoleAdmin.allLocales"),
              allowDelete: false,
              allowEdit: false,
              allowView: false,
            });
            this.locales.add(allLocales, { at: 0 });
          }
          this._continueShow();
        }, this);
      } else {
        this._continueShow();
      }
    },
    _continueShow: function () {
      this._updateLocalesFromRole();
      this.view = new LocaleMapView.localeMapView({ collection: this.locales });

      this.view.on(
        "click:locale:allowDelete",
        function (languageId) {
          var locale = this.locales.get(languageId);
          var allowDelete = !locale.get("allowDelete");
          if (languageId === LOCALE_ALL_ID) {
            this.locales.each(function (l) {
              l.set("allowDelete", allowDelete);
            });
          } else {
            locale.set("allowDelete", allowDelete);
            locale = this.locales.get(LOCALE_ALL_ID);
            // All Locale will not exist if there is a single Locale
            if (locale) {
              locale.set("allowDelete", false);
            }
          }
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:locale:allowEdit",
        function (languageId) {
          var locale = this.locales.get(languageId);
          var allowEdit = !locale.get("allowEdit");
          if (languageId === LOCALE_ALL_ID) {
            this.locales.each(function (l) {
              l.set("allowEdit", allowEdit);
            });
          } else {
            locale.set("allowEdit", allowEdit);
            locale = this.locales.get(LOCALE_ALL_ID);
            // All Locale will not exist if there is a single Locale
            if (locale) {
              locale.set("allowEdit", false);
            }
          }
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:locale:allowView",
        function (languageId) {
          var locale = this.locales.get(languageId);
          var allowView = !locale.get("allowView");
          if (languageId === LOCALE_ALL_ID) {
            this.locales.each(function (l) {
              l.set("allowView", allowView);
            });
          } else {
            locale.set("allowView", allowView);
            locale = this.locales.get(LOCALE_ALL_ID);
            // All Locale will not exist if there is a single Locale
            if (locale) {
              locale.set("allowView", false);
            }
          }
          this.view.render();
        },
        this,
      );

      this.showRegion(this.view);
    },
    _createAllPrivilege: function (privId) {
      var privilege = new KbRoleModel.kbRolePrivilege({
        kbRoleId: this.kbRole.get("id"),
        privId: privId,
        privName: PrivilegeEnum.getPrivilegeName(privId),
      });
      return privilege;
    },
    _createLocalePrivilege: function (privId, languageId) {
      var privilege = new KbRoleModel.kbRolePrivilege({
        foreignKey: languageId,
        foreignTable: LOCALE_TABLE_NAME,
        kbRoleId: this.kbRole.get("id"),
        privId: privId,
        privName: PrivilegeEnum.getPrivilegeName(privId),
      });
      return privilege;
    },
    _updateLocalesFromRole: function () {
      this.locales.each(function (locale) {
        locale.set("allowDelete", false);
        locale.set("allowEdit", false);
        locale.set("allowView", false);
      });
      this.kbRole.privileges().each(function (privilege) {
        var locale;
        switch (privilege.get("privId")) {
          case PrivilegeEnum.LocaleDeleteAll:
            locale = this.locales.get(LOCALE_ALL_ID);
            locale.deletePrivilege = privilege;
            this.locales.each(function (l) {
              l.set("allowDelete", true);
            });
            break;
          case PrivilegeEnum.LocaleEditAll:
            locale = this.locales.get(LOCALE_ALL_ID);
            locale.editPrivilege = privilege;
            this.locales.each(function (l) {
              l.set("allowEdit", true);
            });
            break;
          case PrivilegeEnum.LocaleViewAll:
            locale = this.locales.get(LOCALE_ALL_ID);
            locale.viewPrivilege = privilege;
            this.locales.each(function (l) {
              l.set("allowView", true);
            });
            break;
          case PrivilegeEnum.LocaleDeleteSpecific:
            locale = this.locales.get(privilege.get("foreignKey"));
            if (locale) {
              locale.set("allowDelete", true);
              locale.deletePrivilege = privilege;
            }
            break;
          case PrivilegeEnum.LocaleEditSpecific:
            locale = this.locales.get(privilege.get("foreignKey"));
            if (locale) {
              locale.set("allowEdit", true);
              locale.editPrivilege = privilege;
            }
            break;
          case PrivilegeEnum.LocaleViewSpecific:
            locale = this.locales.get(privilege.get("foreignKey"));
            if (locale) {
              locale.set("allowView", true);
              locale.viewPrivilege = privilege;
            }
            break;
        }
      }, this);
    },
    getPrivileges: function () {
      var newPrivileges = [];
      this.locales.each(function (locale) {
        var privilege;
        var languageId = locale.get("id");
        if (languageId == LOCALE_ALL_ID) {
          if (locale.get("allowDelete")) {
            privilege = locale.deletePrivilege;
            if (!privilege) {
              privilege = this._createAllPrivilege(PrivilegeEnum.LocaleDeleteAll);
              locale.deletePrivilege = privilege;
            }
            newPrivileges.push(privilege);
          }
          if (locale.get("allowEdit")) {
            privilege = locale.editPrivilege;
            if (!privilege) {
              privilege = this._createAllPrivilege(PrivilegeEnum.LocaleEditAll);
              locale.editPrivilege = privilege;
            }
            newPrivileges.push(privilege);
          }
          if (locale.get("allowView")) {
            privilege = locale.viewPrivilege;
            if (!privilege) {
              privilege = this._createAllPrivilege(PrivilegeEnum.LocaleViewAll);
              locale.viewPrivilege = privilege;
            }
            newPrivileges.push(privilege);
          }
        } else {
          if (locale.get("allowDelete")) {
            privilege = locale.deletePrivilege;
            if (!privilege) {
              privilege = this._createLocalePrivilege(
                PrivilegeEnum.LocaleDeleteSpecific,
                languageId,
              );
              locale.deletePrivilege = privilege;
            }
            newPrivileges.push(privilege);
          }
          if (locale.get("allowEdit")) {
            privilege = locale.editPrivilege;
            if (!privilege) {
              privilege = this._createLocalePrivilege(PrivilegeEnum.LocaleEditSpecific, languageId);
              locale.editPrivilege = privilege;
            }
            newPrivileges.push(privilege);
          }
          if (locale.get("allowView")) {
            privilege = locale.viewPrivilege;
            if (!privilege) {
              privilege = this._createLocalePrivilege(PrivilegeEnum.LocaleViewSpecific, languageId);
              locale.viewPrivilege = privilege;
            }
            newPrivileges.push(privilege);
          }
        }
      }, this);
      return newPrivileges;
    },
  });

  return LocaleMapController;
});
